import React, { Component } from 'react';
import { shape, string, number, bool, objectOf } from 'prop-types';
import styles from './styles.scss';
import classnames from 'classnames';

export default class ChannelsTableSummary extends Component {
  static propTypes = {
    summaryData: shape({
      title: string,
      ads: number,
      uniqueAds: number,
      adVisits: number,
      visitOfAds: number,
      avgAdCost: number
    }).isRequired,
    title: string,
    hideChannelFields: bool,
    tableColumns: objectOf(shape({
      title: string,
      key: string
    }))
  }

  static defaultProps = {
    title: 'Grand Total'
  }

  render() {
    const { title, summaryData, hideChannelFields, tableColumns } = this.props;
    const {
      ads,
      adVisits,
      visitOfAds,
      avgAdCost,
      uniqueAds = 0,
      newAdUsers,
      newAdUsersOfAds,
    } = summaryData;
    const formattedTotalAdVisits = `${Math.round(adVisits).toLocaleString()} (100%)`;
    const formattedNewAdUsers = `${Math.round(newAdUsers).toLocaleString()} (100%)`;
    const uniqueAdsLabel = `${uniqueAds ? uniqueAds.toLocaleString() : 0} Unique Ads`;
    const formattedData = {
      trafficType: title,
      adVisits: formattedTotalAdVisits,
      ads: ads.toLocaleString(),
      visitOfAds: visitOfAds.toLocaleString(),
      avgAdCost: avgAdCost != null && `$${avgAdCost.toFixed(2).toLocaleString()}`,
      newAdUsers: formattedNewAdUsers,
      newAdUsersOfAds: newAdUsersOfAds.toLocaleString()
    };

    return (
      <div className={classnames(styles.tableRow, styles.summaryRow)}>
        {
          Object.keys(tableColumns).map(key => {
            if (key === 'ads') {
              return (
                  <div key={key} className={hideChannelFields ? styles.tableCellWhenHideChannelFields : styles.tableCell}>
                    <div className={styles.adsContainer}>
                    <span data-test="summaryAds" className={styles.adsValue}>
                      {formattedData[key]}
                    </span>
                    <div data-test="summaryAdsLabel" className={styles.uniqueContainer}>
                      {uniqueAdsLabel}
                    </div>
                  </div>
                </div>
              )
            }

            return (key !== 'avgAdCost' || avgAdCost != null) &&
              (<div
                key={key}
                className={hideChannelFields ? styles.tableCellWhenHideChannelFields : styles.tableCell}
                data-test={tableColumns[key].summaryTestKey}
              >
                {formattedData[key]}
              </div>
              )
            })
        }
      </div>
    )
  }
}
